// extracted by mini-css-extract-plugin
module.exports = {"root":"IconSocialMediaFacebookRegister_root__1Df5_"};